import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FormikProvider, useFormik } from 'formik';
import { useParams } from 'react-router-dom';
import { Button } from '../../../components';
import { BackIcon } from '../../../assets';
import { Navigation } from '../../../utils/navigation';
import { fetchHealthOrganization } from '../../../store/health_organizations';
import { getUserDetails, updateMultiSiteFacilities } from '../../../store/users';
import { MultiSiteAdminForm, toOrgList } from './MultiSiteAdminForm';
import styles from './index.module.css';

const UpdateMultiSiteAdmin = ({
  currentHealthOrganization,
  organizationId,
  userDetails,
  fetchHealthOrganization,
  getUserDetails,
  updateMultiSiteFacilities,
}) => {
  const { userId } = useParams();
  const navigate = Navigation();
  const facilities = currentHealthOrganization?.id === organizationId ? currentHealthOrganization.children || [] : [];
  const activeFacilities = facilities.filter((facility) => !facility.disabled);
  const admin = userDetails?.id === userId ? userDetails : null;

  useEffect(() => {
    if (organizationId) {
      fetchHealthOrganization(organizationId);
    }
    getUserDetails(userId);
  }, [fetchHealthOrganization, getUserDetails, organizationId, userId]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      firstName: admin?.firstName || '',
      lastName: admin?.lastName || '',
      email: admin?.email || '',
      facilityIds: (admin?.permissions?.orgList || []).map((facility) => facility.id),
    },
    onSubmit: (values) => {
      updateMultiSiteFacilities({
        id: userId,
        Navigation: navigate,
        orgList: toOrgList(values.facilityIds, activeFacilities),
      });
    },
  });

  return (
    <div className={styles.pageContent}>
      <div className={styles.header}>
        <div className={styles.titleRow}>
          <div className={styles.backBtn} onClick={() => navigate.back()}>
            <BackIcon width="26px" height="26px" fill="#E1F4D3" />
          </div>
          <h1 className={styles.pageTitle}>Multi-Site Admin Facilities</h1>
        </div>
      </div>
      <FormikProvider value={formik}>
        <form className={styles.form} onSubmit={formik.handleSubmit}>
          <MultiSiteAdminForm
            values={formik.values}
            setFieldValue={formik.setFieldValue}
            facilities={activeFacilities}
            disableIdentity
          />
          <div className={styles.btnPanel}>
            <Button myClassName={styles.navigationBtn} onClick={() => navigate.back()}>
              Cancel
            </Button>
            <Button type="submit" disabled={formik.values.facilityIds.length < 1}>
              Save Facilities
            </Button>
          </div>
        </form>
      </FormikProvider>
    </div>
  );
};

const mapStateToProps = (state) => ({
  currentHealthOrganization: state.healthOrganizations.currentHealthOrganization,
  organizationId: state.authorization.user?.organizationId,
  userDetails: state.users.userDetails,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ fetchHealthOrganization, getUserDetails, updateMultiSiteFacilities }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(UpdateMultiSiteAdmin);
